import { allFeaturesAtFalse } from './default';
export const features = {
    ...allFeaturesAtFalse,
    home: {
        ...allFeaturesAtFalse.home,
        advantages: true,
    },
    contact: {
        mailTo: 'contact.moulins.soufflet@episens.fr',
    },
    footer: {
        social: {
            facebook: 'https://www.facebook.com/MoulinsSoufflet/',
            linkedin: 'https://www.linkedin.com/company/moulinssoufflet/',
            youtube: 'https://www.youtube.com/@EpisensbyInVivo',
            instagram: 'https://www.instagram.com/moulinssoufflet/',
        },
        sitemap: [
            {
                title: 'Nos services',
                links: [
                    {
                        label: 'Nos produits',
                        internalTo: { path: '/search' },
                    },
                    {
                        label: 'Accès espace client',
                        internalTo: { name: 'login' },
                    },
                    {
                        label: 'Newsletter',
                        hubspotForm: {
                            name: 'newsletter',
                            portalId: "145811218",
                            formId: "6a196b95-f3d0-4874-a947-783214980fa6",
                            region: "eu1"
                        },
                    },
                ],
            },
            {
                title: "Besoin d'une information ?",
                links: [
                    {
                        label: 'Questions fréquentes',
                        internalTo: { path: '/article/questions-frequentes' },
                    },
                    {
                        label: 'Nous contacter',
                        hubspotForm: {
                            name: 'contact-us',
                            portalId: "145811218",
                            formId: "ee03ac86-9933-49b0-8950-013a3fc28d3e",
                            region: "eu1"
                        }
                    },
                    {
                        label: 'Tel :  01 60 90 41 10',
                        textOnly: true,
                    },
                    {
                        label: 'moulins.soufflet.tlv@invivo-group.com',
                        mailTo: 'moulins.soufflet.tlv@invivo-group.com',
                    },
                    {
                        label: 'Du lundi au vendredi,',
                        textOnly: true,
                    },
                    {
                        label: 'de 7h30 à 16h',
                        textOnly: true,
                    },
                ],
            },
        ],
    },
    checkoutV2: {
        displayMention: true
    }
};
//# sourceMappingURL=episens.js.map